import { useState } from 'react';
import { useCreateAdaptedFictionEditionComment } from '../../../domains/scene/ui/hooks/useCreateAdaptedFictionEditionComment';
import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys';

interface UseCreateCommentProps {
  adaptedFictionEditionId: string;
  adaptedFictionPreviewId: string;
}

export const useCreateComment = ({
  adaptedFictionEditionId,
  adaptedFictionPreviewId
}: UseCreateCommentProps) => {
  const [comment, setComment] = useState('');
  const [isAnonymous, setIsAnonymous] = useState(false);

  const castRelationshipId =
    localStorage.getItem(LOCAL_STORAGE_KEYS.CURRENT_CAST_RELATIONSHIP_ID) ?? '';

  const { mutateAsync: createAdaptedFictionEditionComment } = useCreateAdaptedFictionEditionComment(
    {
      adaptedFictionEditionId
    }
  );

  const handleCreateAdaptedFictionEditionComment = async (parentId?: string) => {
    const requestBody = {
      comment: {
        content: comment,
        parent_id: parentId ? parentId : null,
        anonymous: isAnonymous,
        engagement_contexts: [
          {
            context_type: 'AdaptedFictionPreview' as const,
            context_id: adaptedFictionPreviewId
          },
          {
            context_type: 'CastRelationship' as const,
            context_id: castRelationshipId
          }
        ]
      }
    };
    const response = await createAdaptedFictionEditionComment(requestBody);
    if (response.commentId) {
      setComment('');
    }
  };

  return {
    comment,
    setComment,
    isAnonymous,
    setIsAnonymous,
    handleCreateAdaptedFictionEditionComment
  };
};
